import React from 'react';
import MarketplaceCloseIcon from '../../../shared/components/Icons/MarketplaceClose';
import Styled from './styled';
import useModal from '../../../hooks/useModal';

interface Props {
  onClickOverlay: () => void;
  width?: number;
  children: any;
}
const Modal = ({ onClickOverlay, width, children }: Props) => {
  const { stopPropagation } = useModal({ onClickOverlay });

  return (
    <Styled.Overlay onClick={onClickOverlay}>
      <Styled.Modal width={width} onClick={stopPropagation}>
        <Styled.Container>
          <Styled.Close onClick={onClickOverlay}>
            <MarketplaceCloseIcon />
          </Styled.Close>
          {children}
        </Styled.Container>
      </Styled.Modal>
    </Styled.Overlay>
  );
};

export default Modal;
